import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import { API_URL } from '../../../../config/constants';
import FullscreenToggle from '../components/FullscreenToggle';
import ImageModal from '../components/ImageModal';

const Images = ({ evisitId, onExpand, onContract, isActive, appSocket }) => {
	const [isImageModalOpen, setImageModalOpen] = useState(false);
	const [imageSrc, setImageSrc] = useState();
	const [{ data: imageFilenames = [], /* error: imageFilenamesError */ }, getImageFilenames] = useAxios(`/evisit_images/${evisitId}/files`);

	useEffect(() => {
		appSocket.on('photos uploaded', getImageFilenames);
		return function cleanUp() {
			appSocket.removeAllListeners('photos uploaded');
		};
	}, []);

	useEffect(() => {
		if (isActive) {
			// getImageFilenames();
		}
	}, [isActive]);

	const handleImageClick = (event) => {
		setImageSrc(event.target.src);
		setImageModalOpen(true);
	};

	// TODO reload images if patient sends one in chat

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			<div className="images">
				<ImageModal
					isOpen={isImageModalOpen}
					onClose={() => setImageModalOpen(false)}
					imageSrc={imageSrc}
				/>
				<div className="row mb-lg">
					{imageFilenames.map(({ container, name }) => (
						<div className="col-md-4 mb-lg" key={`${container}/${name}`}>
							<img
								src={`${API_URL}/evisit_images/${container}/download/${name}`}
								onClick={handleImageClick}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

Images.propTypes = {
	evisitId: PropTypes.number.isRequired,
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
	isActive: PropTypes.bool,
	appSocket: PropTypes.object
};

export default Images;
